import { Box, Grid, Typography } from "@mui/material";
import TruckCard from "../HomePage/Sections/Cards/TruckCard";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { API_endpoints } from "../../API/API_Endpoints";
import { API_GET, API_GET_OPEN } from "../../API/config";
import { useLocation, useParams } from "react-router-dom";
import { NavRoutes } from "../../Component/Navbar/NavRoutes";
import CatServiceCard from "../HomePage/Sections/Cards/CatServiceCard";
import TruckCardSkeleton from "../HomePage/Sections/Skeleton/TruckCardSkeleton";
import CatererCardSkeleton from "../HomePage/Sections/Skeleton/CatererCardSkeleton";

const MoreTruckList = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCaterer, setIsCaterer] = useState(false);
  const userData = JSON.parse(localStorage.getItem("Fiesta"));
  const { id } = useParams();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  const getData = async () => {
    try {
      setLoading(true);

      if (isCaterer) {
        const response = await API_GET(
          `${API_endpoints.getallcaterers}?count=0&offset=20`
        );
        if (response?.s && response?.r) {
          let filteredData = response.r;
          if (id) {
            filteredData = filteredData.filter(
              (x) => x?.id != Number(id) && x?.user_id != Number(userData?.id)
            );
          }
          if (filteredData.length > 3) {
            const shuffled = [...filteredData];
            for (let i = shuffled.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
            }
            setData(shuffled.slice(0, 3));
          } else {
            setData(filteredData);
          }
        } else {
          setData([]);
        }
      } else {
        const response = await API_GET_OPEN(
          `${API_endpoints.getalltrucks}?count=0&offset=20`
        );
        if (response?.s && response?.r) {
          let filteredData = response.r;
          if (id) {
            filteredData = filteredData.filter(
              (x) => x?.id !== Number(id) && x?.user_id !== Number(userData?.id)
            );
          }

          if (filteredData.length > 3) {
            const shuffled = [...filteredData];
            for (let i = shuffled.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
            }
            setData(shuffled.slice(0, 3));
          } else {
            setData(filteredData);
          }
        } else {
          setData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setIsCaterer(location.pathname.includes(NavRoutes.COMPANY_DETAILS));
  }, [location.pathname]);

  useEffect(() => {
    getData();
  }, [isCaterer, id]);

  return (
    <Box
      sx={{
        px: { xs: 3, md: 5 },
        width: "100%",
        maxWidth: "1440px",
        margin: "0 auto",
      }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            my: 2,
          }}
        >
          <Typography
            sx={{ fontSize: { xs: "25px", sm: "22px" } }}
            fontWeight={600}
          >
            {isCaterer
              ? t("foodTruck.discoverMoreCaterer")
              : t("foodTruck.discoverMoreTruck")}
          </Typography>
        </Box>

        <Box sx={{ minHeight: "150px", pb: 4 }}>
          {loading ? (
          
            <Grid container spacing={3}>
              {[...Array(3)].map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  {isCaterer ? <CatererCardSkeleton /> : <TruckCardSkeleton />}
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={3} sx={{ justifyContent: "center" }}>
              {data?.length > 0 ? (
                data.map((item, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3.8}
                    key={`discover-more-${item.id || index}`}
                    sx={{
                      transition: "transform 0.3s ease-in-out",
                    }}
                  >
                    {isCaterer ? (
                      <CatServiceCard data={item} />
                    ) : (
                      <TruckCard
                        data={{ ...item, avg_rating: item?.avg_rating }}
                        title={t("explore.moreDetails")}
                        openModal={false}
                      />
                    )}
                  </Grid>
                ))
              ) : (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    mt: 4,
                  }}
                >
                  <Typography variant="body1">
                    {t("myCompDetails.noData")}
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Box>

      {/* <FoodTruckEditModal
        setOpen={setOpen}
        open={open}
        data={truckData}
        getData={getData}
        compID={Number(companyId)}
      /> */}
    </Box>
  );
};

export default MoreTruckList;
